import React, { createContext, useContext, useEffect, useState } from 'react'
import SemanticSnackBar from '../components/SemanticSnackBar'

export const SnackBarContext = createContext(null)
export const useSnackbarContext = () => useContext(SnackBarContext)
const AUTO_DISMISS = 5000

export function SnackBarProvider({ children }) {
  const [alerts, setAlerts] = useState([])

  const activeAlertIds = alerts.join(',')
  useEffect(() => {
    if (activeAlertIds.length > 0) {
      const timer = setTimeout(
        () => setAlerts(alerts => alerts.slice(0, alerts.length - 1)),
        AUTO_DISMISS
      )
      return () => clearTimeout(timer)
    }
  }, [activeAlertIds])

  const addAlert = alert => setAlerts(alerts => [alert, ...alerts])

  const value = { addAlert }

  return (
    <SnackBarContext.Provider value={value}>
      {children}
      {alerts.map(alert => (
        <SemanticSnackBar variant={alert.variant} key={alert}>
          {alert.text}
        </SemanticSnackBar>
      ))}
    </SnackBarContext.Provider>
  )
}

export const withSnackbar = Component => {
  return function WrappedComponent(props) {
    const snackbarContext = {
      ...useSnackbarContext(),
    }
    return <Component {...props} snackBars={{ ...snackbarContext }} />
  }
}
